module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_vm._v("For my grandmother and staunchest"), _c('br'), _vm._v("supporter, Leokadjia “Lillian” B. Kelley,"), _c('br'), _vm._v("whose indomitable strength came"), _c('br'), _vm._v("at such a high cost")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0vii-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 66
// module chunks = 0